import React, { FC } from 'react'

import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'

import Table from '../../../components/Table/Table'
import { useAppSelector } from '../../../store/hooks'
import { Trade } from '../../TradingLog/types'
import { DailyStatsBodyProps } from '../types'

export const DailyStatsCardBody: FC<DailyStatsBodyProps<Trade>> = ({
  sortingProps,
  keyForRefresh,
  onAnalysisSaved,
}) => {
  const { spacing } = useTheme()
  const { sortingColumn, sortedTrades, handleSort, handleColumnReorder, sortingDirection } =
    sortingProps
  const { columns } = useAppSelector((state) => state.dailyStats.pagination)

  return (
    <Box mt={spacing(1)} width={'100%'}>
      <Table
        columnOrder={columns}
        sortingColumn={sortingColumn}
        sortingDirection={sortingDirection}
        onColumnReorder={handleColumnReorder}
        onSort={handleSort}
        displayedTrades={sortedTrades}
        keyForRefresh={keyForRefresh}
        onAnalysisSaved={onAnalysisSaved}
      />
    </Box>
  )
}
